import { compose, lifecycle, withProps, withState } from "recompose";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { createErrorsSelector } from "core/helpers";
import * as stripe from "core/integrations/stripe";
import * as paymentSelectors from "modules/payment/selectors";
import View from "./View";

const nodeId = "stripe-form";

export default compose(
  withState("submitStripe", "setSubmitStripe", null),
  withState("error", "setError", null),
  withProps({
    nodeId
  }),
  connect(
    createStructuredSelector({
      isPaying: paymentSelectors.isPaying,
      serverErrors: createErrorsSelector(paymentSelectors.submitPaymentApi)
    }),
    (dispatch, { onGetToken, submitStripe, setError }) => ({
      onSubmit: e => {
        e.preventDefault();

        submitStripe(onGetToken, setError);
      }
    })
  ),
  lifecycle({
    async componentDidMount() {
      const submitStripe = await stripe.load(nodeId, this.props.setError);
      this.props.setSubmitStripe(() => submitStripe);
    }
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Payment/components/Stripe/Provider.js